import axiosInstance from './axiosInstance';

const addPrediction = async (prediction) => {
  const response = await axiosInstance.post('/predictions', prediction);
  return response.data;
};

const updatePrediction = async (prediction) => {
  const response = await axiosInstance.put('/predictions', prediction);
  return response.data;
};

const getPredictionsByLeagueAndUser = async (leagueId) => {
  const lid = encodeURIComponent(String(leagueId));
  const response = await axiosInstance.get(`/predictions/league-and-user/${lid}`);
  return response.data;
};

const getPredictionsByLeagueAndUserId = async (leagueId, userId) => {
  const lid = encodeURIComponent(String(leagueId));
  const uid = encodeURIComponent(String(userId));
  const response = await axiosInstance.get(`/predictions/league-and-user/${lid}/${uid}`);
  return response.data;
};

// Tipy všech hráčů ligy na jeden zápas (stránkovaně, page je 0-based).
// Backend je vrací až po výkopu zápasu.
// Volitelný `username` filtruje podle části jména (bez ohledu na velikost písmen).
const getPredictionsByLeagueAndMatch = async (leagueId, matchId, page = 0, size = 10, username = '') => {
  const lid = encodeURIComponent(String(leagueId));
  const mid = encodeURIComponent(String(matchId));
  const params = { page, size };
  if (username) params.username = username;
  const response = await axiosInstance.get(`/predictions/league/${lid}/match/${mid}`, { params });
  const data = response.data;
  return {
    items: Array.isArray(data?.content) ? data.content : [],
    total: typeof data?.totalElements === 'number' ? data.totalElements : 0,
  };
};

export default { addPrediction, getPredictionsByLeagueAndUser, updatePrediction, getPredictionsByLeagueAndUserId, getPredictionsByLeagueAndMatch };